import React from 'react';
import { connect } from 'react-redux';
import { createSelector } from '@reduxjs/toolkit';
import { useMobile } from '@ff-os/shared-react/hooks/useMobile';
import { selectNameByVariableId, selectSizeByVariableId } from '@ff-scene-plugins/gift-redux/slices/variablesSlice';
import { GiftPdpState } from '@ff-scene-plugins/gift-redux/store';
import { selectCollectionIdById, selectOpenByDefaultOrWhenWindowed, selectThumbnailAssetUrlById } from './_redux';
import { EngravingInputControlAccordion } from './partials/EngravingInputControlAccordion';
import { EngravingInputControlMobile } from './partials/EngravingInputControlMobile';

const _EngravingInputControl = ({ hasSingleNonPinnedVariable, ...props }: Props) => {
    const isMobile = useMobile();
    if (isMobile) {
        return <EngravingInputControlMobile {...props} />;
    } else {
        return <EngravingInputControlAccordion {...props} />;
    }
};

type Props = {
    name: string;
    variableIds: string[];
    selectedAssetUrl: string;
    openByDefault: boolean;
    shouldDisplayIcon: boolean;
    hasSingleNonPinnedVariable: boolean;
    isContentFirst: boolean;
};

const mapStateToProps = (state: GiftPdpState, ownProps: { variableIds: string[] }) => ({
    name: selectNameByVariableId(state, ownProps.variableIds[0])!,
    shouldDisplayIcon: selectShouldDisplayIcon(state, ownProps.variableIds[0])!,
    collectionId: selectCollectionIdById(state, ownProps.variableIds[0])!,
    selectedAssetUrl: selectThumbnailAssetUrlById(state, ownProps.variableIds[0])!,
    openByDefault: selectOpenByDefaultOrWhenWindowed(state, ownProps.variableIds[0])!,
    isContentFirst: state.scene.options?.contentFirst ?? false
});

export const EngravingInputControl = connect(
    mapStateToProps
)(_EngravingInputControl);

const selectShouldDisplayIcon = createSelector(
    (state: GiftPdpState, id: string) => selectSizeByVariableId(state, id)!,
    ({ width, height }) => width < height * 1.5
        && height < width * 1.5);